import axios from 'axios'

import { parseResponse, handleError } from '@/_helpers/utils.js'

const state = {
  loading: true,
  error: null,
  list: [],
  manager: null,
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    count: 20
  },
  sorting: {
    name: null,
    order: 'asc'
  }
}

const actions = {
  get_list ({commit, state, dispatch}, params) {
    commit('fetch')

    return axios.get('/1.0/admin/company-personal-manager', {params})
      .then(response => {
        const data = parseResponse(response);

        commit('fetch_list_success', {data: data.data, meta: data.meta});
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, {root: true})
        commit('fetch_failure', error)
      })
  },

  get_manager ({commit, state, dispatch}, {id}) {
    commit('fetch')

    return axios.get(`/1.0/admin/company-personal-manager/${id}`)
      .then(response => {
        const data = parseResponse(response).data[0];

        commit('fetch_manager_success', {data});
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, {root: true})
        commit('fetch_failure', error)
      })
  },

  create_manager ({ commit, state, dispatch }, data) {
    return axios.post('/1.0/admin/company-personal-manager', {managers: [data]})
      .then(response => {
        const data = parseResponse(response).data[0];

        commit('fetch_manager_success', {data});
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetch_failure', error);

        throw error;
      })
  },

  remove_manager ({ commit, state, dispatch }, data) {
    return axios.delete(`/1.0/admin/company-personal-manager/${data.id}`)
      .then(response => {
        return parseResponse(response).data[0];
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetch_failure', error);

        throw error;
      })
  },

  update_list ({ commit, state, dispatch }, data) {
    return axios.put(`/1.0/admin/company-personal-manager`, {managers: data})
      .then(response => {
        const data = parseResponse(response);

        commit('fetch_list_success', {data: data.data, meta: data.meta});
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetch_failure', error);
      })
  },

  add_manager_to_company ({ commit, state, dispatch }, data) {
    return axios.put(`/1.0/admin/company-personal-manager/relation-to-company`, {managers: data})
      .then(response => {
        const data = parseResponse(response);

        return data;
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetch_failure', error);
      })
  },

  remove_manager_from_company ({ commit, state, dispatch }, data) {
    return axios.delete(`/1.0/admin/company-personal-manager/relation-to-company`, {managers: data})
      .then(response => {
        return parseResponse(response).data[0];
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetch_failure', error);

        throw error;
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetch_list_success (state, {data, meta}) {
    state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count)
    state.list = data
    state.loading = false
  },

  fetch_manager_success (state, {data}) {
    state.manager = data
    state.loading = false
  },

  fetch_failure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  clear_list  (state, err) {
    state.list = [];
  },

  clear_manager  (state, err) {
    state.manager = null;
  },

  clear  (state, err) {
    state.list = [];
    state.manager = null;
  },

  updatePagination (state, params) {
    state.pagination = Object.assign(state.pagination, params)
  },

  updateSorting (state, data) {
    Object.assign(state.sorting, data)
  },

  updateFilters (state, data) {
    Object.assign(state.filters, data)
  }
}

const getters = {
  loading (state, getters) {
    return state.loading
  },

  list: (state, getters) => {
    return state.list
  },

  manager: (state, getters) => {
    return state.manager
  },

  pagination: (state, getters) => {
    return state.pagination
  },

  sorting: (state, getters) => {
    return state.sorting
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
